import React from 'react';
import PaypalRadioButton from './paypal_radio_button';
import PaypalProfile from './shop_paypal_profile';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import PaypalOnboardingButton from './PaypalOnboardingButton';

interface Props {
  hasPaypalProfile: boolean;
  shopCurrency: string;
  inputName: string;
  onPaymentProviderChange(event: React.ChangeEvent<HTMLInputElement>): void;
  errorMessages: string[];
  paypalProfileCreatedAt: string;
  paypalProfileFormPrefix: string;
  paypalAccountLink: string;
  userAttributes: { firstName: string; lastName: string };
  selected: boolean;
  partnerOnboarded: boolean;
  onboardingPending: boolean;
  userLockedForPaypalNoncompliance: boolean;
  partnerReferralTrackingId: string;
  listingId?: string;
}

export default function PaymentProviderPaypalOption(props: Props) {
  const inPaypalSellerOnboardingExp = useExpEnabled(experiments.PAYPAL_SELLER_ONBOARDING);

  return (
    <div>
      <PaypalRadioButton
        inputName={props.inputName}
        checked={props.selected}
        handleChangePaymentMethod={props.onPaymentProviderChange}
        shopCurrency={props.shopCurrency}
      />
      {props.selected &&
        inPaypalSellerOnboardingExp &&
          <PaypalOnboardingButton
            partnerOnboarded={props.partnerOnboarded}
            onboardingPending={props.onboardingPending}
            hasPaypalProfile={props.hasPaypalProfile}
            userLockedForPaypalNoncompliance={props.userLockedForPaypalNoncompliance}
            partnerReferralTrackingId={props.partnerReferralTrackingId}
            listingId={props.listingId}
          />
      }
      {props.selected &&
        !inPaypalSellerOnboardingExp &&
          <PaypalProfile
            errorMessages={props.errorMessages}
            createdAt={props.paypalProfileCreatedAt}
            formPrefix={props.paypalProfileFormPrefix}
            paypalAccountLink={props.paypalAccountLink}
            userAttributes={props.userAttributes}
          />
      }
    </div>
  );
}
